import React from 'react';
import { Clock, UserCheck, ShieldCheck } from 'lucide-react';
export function ValueProps() {
  const values = [{
    icon: <Clock className="w-8 h-8 text-apex-green" strokeWidth={2.5} data-id="element-202" />,
    title: '48 Hour Turnaround',
    description: 'Get your listing photo-ready before the photographer arrives. Most jobs completed in two business days or less.'
  }, {
    icon: <UserCheck className="w-8 h-8 text-apex-green" strokeWidth={2.5} data-id="element-203" />,
    title: 'One Point Of Contact',
    description: 'No coordinating multiple vendors. We handle yard, exterior, debris, and detail work in a single visit.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-apex-green" strokeWidth={2.5} data-id="element-204" />,
    title: 'Listing Ready Guarantee',
    description: "If it's not ready when we say it is, we make it right. Realtors come first, every time."
  }];
  return <section id="about" className="bg-apex-light py-20 md:py-28" data-id="element-205">
      <div className="container mx-auto px-4 md:px-6" data-id="element-206">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-207">
          <span className="text-apex-green font-bold text-sm uppercase tracking-[0.2em] block mb-4" data-id="element-208">
            Why Apex
          </span>
          <h2 className="text-apex-charcoal font-extrabold text-3xl md:text-5xl tracking-tight" data-id="element-209">
            Your listings deserve an unfair advantage.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-210">
          {values.map((value, index) => <div key={index} className="bg-white p-8 rounded-md shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-211">
              <div className="mb-6 bg-apex-light w-16 h-16 rounded-full flex items-center justify-center" data-id="element-212">
                {value.icon}
              </div>
              <h3 className="text-xl font-bold text-apex-charcoal mb-3" data-id="element-213">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-214">
                {value.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}